// extracted by mini-css-extract-plugin
export default {"service-provided-list-container":"OutboundCustomerInvoice_service-provided-list-container__iUyvb","prefix-label":"OutboundCustomerInvoice_prefix-label__nGgyt"};